import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { Customer } from '../Customer/types';
import StatusDot, { StatusStyle } from '../Status/StatusDot';
import { Column } from '../../hooks/useTablePages';
import React from 'react';

const customerColumns: Column[] = [
  {
    header: 'Status',
    id: 'status',
    accessor: (row: Customer) => {
      let style: StatusStyle = 'default';

      if (row.status !== 'INACTIVE') {
        style = 'success';
      } else {
        style = 'error';
      }

      return <StatusDot status={style} mr="1" />;
    },
    stringAccessor: (row: Customer): string => {
      return constantToLabel(row.status);
    },
    width: 66,
  },
  {
    header: 'Customer Name',
    id: 'profile.id',
    accessor: (row: Customer) => row.profile.name,
    width: 225,
  },
];

export default customerColumns;
